/*
 * 订单确认
 * */
import request from "@utils/request";

/**
 * 通过购物车 id 获取订单信息
 * @param cartId
 * @returns {*}
 */
export function postOrderConfirm(data) {
  return request.post("/order/confirm", data);
}

/**
 * 计算订单金额
 * @param key
 * @param data
 * @returns {*}
 */
export function postOrderComputed(key, data) {
  return request.post("/order/computed/" + key, data);
}

/**
 * 获取指定金额可用优惠券
 * @param price
 * @returns {*}
 */
export function getOrderCoupon(price) {
  return request.get("/coupons/order/" + (parseFloat(price) || 0));
}

/**
 * 生成订单
 * @param key
 * @param data
 * @returns {*}
 */
export function createOrder(key, data) {
  return request.post("/order/create/" + key, data || {});
}

/**
 * 订单统计数据
 * @returns {*}
 */
export function getOrderData(ordertype) {
  return request.get("/order/data?is_judge=" + ordertype);
}

/**
 * 订单列表
 * @returns {*}
 */
export function getOrderList(data) {
  return request.get("/order/list", data);
}
export function getOfflinelist(data) {
  return request.get("offline?uid=" + data);
}
/**
 * 取消订单
 * @returns {*}
 */
export function cancelOrder(id) {
  return request.post("/order/cancel", { id });
}

/**
 * 订单详情
 * @returns {*}
 */
export function orderDetail(id) {
  return request.get("/order/detail/" + id);
}

/**
 * 退款理由
 * @returns {*}
 */
export function getRefundReason(text) {
  return request.get("/order/refund/reason?text=" + text);
}

/**
 * 提交退款
 * @returns {*}
 */
export function postOrderRefund(data) {
  return request.post("/order/refund/verify", data);
}

/**
 * 确认收货
 * @returns {*}
 */
export function takeOrder(uni) {
  return request.post("/order/take", { uni });
}

/**
 * 删除订单
 * @returns {*}
 */
export function delOrder(uni) {
  return request.post("/order/del", { uni });
}

/**
 * 订单查询物流信息
 * @returns {*}
 */
export function express(uni) {
  return request.get("order/express/" + uni);
}

/**
 * 订单查询物流信息
 * @returns {*}
 */
export function payOrder(uni, paytype, from) {
  return request.post("order/pay", { uni, paytype, from });
}

export function getCartList(data) {
  return request.get("cart/list", data);
}
/**
 * 获取购物车列表
 * @param numType boolean true 购物车数量,false=购物车产品数量
 */

export function getCartCounts(numType, merchant_id) {
  return request.get("cart/count", {
    numType: numType === undefined ? true : numType,
    merchant_id: merchant_id
  });
}
/**
 * 修改购物车数量
 * @param int cartId  购物车id
 * @param int number 修改数量
 */

export function changeCartNum(cartId, number) {
  return request.post("cart/num", {
    id: cartId,
    number: number
  });
}
/**
 * 清除购物车
 * @param object ids join(',') 切割成字符串
 */

export function cartDel(ids) {
  if (typeof id === "object") ids = ids.join(",");
  return request.post("cart/del", {
    ids: ids
  });
}
export function cartAll(data) {
  return request.get("cart/all", data);
}
/**
 * 订单商品退换货申请
 * @param key
 * @param data
 * @returns {*}
 */
export function recede(data) {
  return request.post("/order/returns", data);
}
/**
 * 订单商品退换货信息
 * @param key
 * @param data
 * @returns {*}
 */
export function recedeInfo(data) {
  return request.post("/order/returns_info", data);
}
/**
 * 订单商品退换货详情
 * @param key
 * @param data
 * @returns {*}
 */
export function orderReturns(data) {
  return request.get("/order/order_returns", data);
}
/**
 * 订单商品退换货申请超时
 * @param key
 * @param data
 * @returns {*}
 */
export function orderReturnsClose(data) {
  return request.get("/order/returns_close", data);
}
